export default __webpack_public_path__ + "images/ce3e484e10648f4bb53e698ba7e03156.svg";